import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { PublicLayout, PageContainer } from "@/components/PublicLayout";
import { LoadingState, ErrorState } from "@/components/States";
import { ArrowLeft } from "@phosphor-icons/react";

export default function BlogPost() {
  const { slug } = useParams();
  const q = useQuery({
    queryKey: ["blog", slug],
    queryFn: async () => (await api.get(`/blog/${slug}`)).data,
    retry: false,
  });

  return (
    <PublicLayout>
      <PageContainer className="py-10 max-w-3xl">
        <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-1.5 text-sm font-bold text-brand mb-6 hover:gap-2.5 transition-all">
          <ArrowLeft className="w-4 h-4" weight="bold" /> Back to Blog
        </Link>

        {q.isLoading ? (
          <LoadingState />
        ) : q.isError ? (
          <ErrorState message="This article could not be found." />
        ) : (
          <article data-testid="blog-article">
            <span className="text-xs font-bold text-brand uppercase tracking-wider">{q.data.date}</span>
            <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 mt-2 leading-tight">{q.data.title}</h1>
            {q.data.image && (
              <img src={q.data.image} alt={q.data.title} className="w-full aspect-video object-cover rounded-2xl mt-6" />
            )}
            <div className="prose prose-slate mt-6 max-w-none">
              {q.data.body.split("\n").filter(Boolean).map((para, i) => (
                <p key={i} className="text-slate-700 leading-relaxed mb-4">{para}</p>
              ))}
            </div>
          </article>
        )}
      </PageContainer>
    </PublicLayout>
  );
}
